export class Row {
    cells: any;
    readOnly?: boolean;
    aggregated?: any;

    constructor( cells: any, readOnly?: boolean, aggregated?: number ) {
        this.cells = cells;
        this.readOnly = readOnly;
        this.aggregated = aggregated;
    }
}
